<ion-content>

  <ion-grid class="block-modal" >
    <ion-row>
      <ion-col size="12" class="ion-text-center">
        <h1>Acceso bloqueado</h1>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" class="ion-text-center">
        <p>Su usuario ha sido bloqueado del sistema.</p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" class="ion-text-center">
        <ion-button fill="solid" color="primary" (click)="dismiss()">Aceptar</ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
